export default {"src":"/_next/static/media/cross-border-compliance.186f8799.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};